module.exports = __webpack_public_path__ + "static/approach_view-57b97cf36b0975617b4d6fa1d1eff6f2.mp4";